import { useState } from 'react';
import '../css/LineBrowserGuard.css';

function LineBrowserGuard() {
  const agent = navigator.userAgent || '';
  const isAndroid = /Android/i.test(agent);
  const isIOS = /iPhone|iPad|iPod/i.test(agent);
  const isLineBrowser = /Line\//i.test(agent) || (/; wv\)/i.test(agent) && /LIFF/i.test(agent));
  const [copied, setCopied] = useState(false);
  if ((!isAndroid && !isIOS) || !isLineBrowser) return null;

  const currentUrl = window.location.href;
  const url = new URL(currentUrl);
  const intentUrl = `intent://${url.host}${url.pathname}${url.search}${url.hash}#Intent;scheme=${url.protocol.replace(':', '')};package=com.android.chrome;S.browser_fallback_url=${encodeURIComponent(currentUrl)};end`;

  const copyUrl = async () => {
    try { await navigator.clipboard.writeText(currentUrl); setCopied(true); }
    catch { window.prompt('คัดลอกลิงก์นี้แล้วนำไปเปิดใน Safari', currentUrl); }
  };

  return <div className="line-browser-guard" role="alertdialog" aria-modal="true">
    <div><span>🌐</span><h1>เปิดผ่านเบราว์เซอร์ภายนอก</h1><p>ระบบไม่รองรับเบราว์เซอร์ภายใน LINE เนื่องจากกล้อง การแจ้งเตือน และการติดตั้งแอปบนหน้าจออาจทำงานไม่สมบูรณ์</p>{isAndroid ? <a className="line-browser-open-button" href={intentUrl}><b>👆 กดเพื่อเปิด Google Chrome</b><small>แตะปุ่มนี้เพื่อใช้งานต่อ</small></a> : <button className="line-browser-open-button" type="button" onClick={copyUrl}><b>{copied ? '✓ คัดลอกลิงก์แล้ว' : '👆 กดเพื่อเปิด Safari'}</b><small>{copied ? 'เปิด Safari แล้วกดวางลิงก์ได้เลย' : 'ระบบจะคัดลอกลิงก์ให้โดยอัตโนมัติ'}</small></button>}<small>{isIOS ? 'บน iPhone/iPad: หลังแตะปุ่ม ให้เปิด Safari แล้ววางลิงก์ จากนั้นกด Share → เพิ่มไปยังหน้าจอโฮม' : 'หากปุ่มไม่ทำงาน ให้กดเมนู ⋮ ใน LINE แล้วเลือก “เปิดในเบราว์เซอร์อื่น”'}</small></div>
  </div>;
}

export default LineBrowserGuard;
